import { Check } from 'lucide-react';
import { cn } from '../../cn';
import { stageColorVar, type StageView } from '../model/projectView';
import { TypeTag } from './TypeTag';

/** Бейдж подстатуса цвета этапа (концепт compact-rows 1.2.2.1): квадратный, как тег типа файла; у завершающих подстатусов — галочка. */
export function StageChip({ stage, label, className }: { stage: StageView; label: string; className?: string }) {
  return (
    <TypeTag color={stageColorVar(stage.key)} className={cn('nd:min-w-0 nd:gap-[0.3125rem] nd:overflow-hidden nd:tabular-nums', className)}>
      {stage.completed ? <Check className="nd:size-[0.6875rem] nd:shrink-0" strokeWidth={3} aria-hidden="true" /> : null}
      <span className="nd:truncate">{label}</span>
    </TypeTag>
  );
}
